export const numbersData = Array.from({ length: 20 }, (_, i) => {
    const num = i + 1;
    return {
        value: num,
        label: num.toString(),
        color: num % 2 === 0 ? '#4ECDC4' : '#FF6B6B', // Alternating colors
        word: [
            'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
            'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty'
        ][i]
    };
});
